import { useSelector } from 'react-redux';
import { getLabelModels, getLabelModelsStatus } from './index';

export const useModelsStatus = () => useSelector(getLabelModelsStatus);
export const useLabelModels = () => useSelector(getLabelModels);
